import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';

import {
  buildCheckoutItemsSummaryExpression,
  buildOrderItemsBindingsFromCollectionState,
} from './CommerceUtils';
import {Atom, ElementPreset} from '@packages/systems/wfdl';

import {
  CommerceOrderWrapperConstraint,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
} from '@packages/systems/core/constants/SharedConstraintRules';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCheckoutOrderItemsWrapper = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) =>
        renderChild(child, context)
      )}
    </div>
  )
);

export const createCommerceCheckoutOrderItemsWrapper: ElementPreset.ExpressionEscapeHatchFactory =
  ({collectionState, betaFeatures}) => {
    if (collectionState === undefined) {
      throw Error(
        'collectionState is required to instantiate createCommerceCheckoutOrderItemsWrapper elementPreset'
      );
    }

    return buildCheckoutItemsSummaryExpression({
      bindings: buildOrderItemsBindingsFromCollectionState(collectionState),
      betaFeatures: betaFeatures || null,
    });
  };

const config = createIntegratedAtom({
  displayName: 'Order Items',
  showEmpty: true,
  constraints: {
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutOrderItemsList', rule: 'ExactlyOne'},
    ],
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; } | { ...; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceOrderWrapperConstraint,
      {
        // @ts-expect-error - TS2322 - Type 'string | string[] | UnsafeConstraintEscapeHatch | readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]' is not assignable to type 'string | string[] | UnsafeConstraintEscapeHatch'.
        is: 'CommerceCartWrapper',
        rule: 'Forbid',
      },
    ],
    page: [
      {
        is: [
          'ecommerce-checkout',
          'ecommerce-confirmation',
          'ecommerce-paypal-checkout',
        ],
        type: 'UtilityPage',
      },
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  render: CommerceCheckoutOrderItemsWrapper,
  fields: {children: TListOfElement},
});

export default config;
